module.exports = __webpack_public_path__ + "fonts/MaterialIcons-Regular.53436aca.woff2";